module.exports = __webpack_public_path__ + "img/notification-preview-bg.3c22ad6f.png";